import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Global } from 'src/app/global';
import { AuthService } from 'src/app/service/auth/auth.service';

@Component({
  selector: 'app-lista-v2',
  templateUrl: './lista-v2.component.html',
  styleUrls: ['./lista-v2.component.css']
})
export class ListaV2Component implements OnInit {

  visualizar_prontuario:any = false;
  global_: any;
  formattedHeaders: string[] = [];
  @Input() data: any[] = [];
  @Input() headers: string[] = [];
  @Output() imprimir = new EventEmitter<any>()
  @Output() show = new EventEmitter<any>()
  @Output() zap = new EventEmitter<any>()
  @Output() activateDeactivate = new EventEmitter<{id: any, ativo: boolean}>(); 


  constructor(
    private global: Global,
    private authService: AuthService) {

      this.authService.visualizarProntuario.subscribe(res => {
        if (res) {
          this.visualizar_prontuario = res;
        }
      });
     }
  
  

  showItem(item:any){
   
    this.show.emit(item.id)
    
  }

  formatDateTime(dateTime: string): string {
    return this.global.formatDateTimeComplete(dateTime);
  }

  enviarWhatsApp(item: any) {
         this.zap.emit(item.id)
  }

  imprimirDado(item:any) {
     this.imprimir.emit(item.id) 
   
  }

  onActivateDeactivate(item: any, ativo: boolean) {
    this.activateDeactivate.emit({ id: item.id, ativo:item.ativo  });
  }

  ngOnInit(): void {
    this.formattedHeaders = this.headers.map(header => {
      return header.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
    });
  }

}
